import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { Input, Form, Button } from "antd";
import { toast } from "react-toastify";
import { postRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import { LoadingView } from "../common";
import { useNavigate } from "react-router-dom";
import backArrow from "../../assets/images/back-arrow.svg";
import Logo from "../../../src/assets/images/PoweredNew.png";
import "./ChangePassword.scss";

function ChangePassword() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    if (values.newPassword === values.confirmPwd) {
      delete values.confirmPwd;
      try {
        setLoading(true);
        const response = await postRequest(
          userServiceApi.changePassword(),
          values
        );
        if (response === "Success") {
          setLoading(false);
          toast.success("Password Updated Successfuly");
          navigate("/");
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        toast.error(error.error);
      }
    } else {
      setLoading(false);
      toast.error("Password and Confirm Password does not match");
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };

  if (loading) return <LoadingView message="Loading..." />;

  return (
    <div className="tabContainer" style={{ minHeight: "fit-content" }}>
      <div className="main-container" style={{ paddingTop: "5px" }}>
        <div className="header-container">
          <div className="backbtn-container">
            <img src={backArrow} alt="" onClick={() => navigate("/")} />
            <p>Change Password</p>
          </div>
        </div>

        <div className="formInfoStyle changePassword">
          <Form
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <div className="formInfoRow">
              <div className="formInfoCol">
                <Form.Item
                  label="Old Password"
                  name="currentPassword"
                  rules={[
                    {
                      required: true,
                      message: "Please input your old password!",
                    },
                  ]}
                >
                  <Input.Password
                    placeholder="Old Password"
                    style={{ borderRadius: "5px" }}
                    iconRender={(visible) =>
                      visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
                    }
                  />
                </Form.Item>
              </div>
            </div>

            <div className="formInfoRow">
              <div className="formInfoCol">
                <Form.Item
                  label="New Password"
                  name="newPassword"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Please input your new password!",
                    },
                    {
                      min: 8,
                      message: "Password must be at least 8 characters long!",
                    },
                    {
                      pattern:
                        /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])(?!.*\s)/,
                      message:
                        "Password must include uppercase, lowercase, number, special character and must not contain spaces!",
                    },
                  ]}
                >
                  <Input.Password
                    placeholder="New Password"
                    style={{ borderRadius: "5px" }}
                    iconRender={(visible) =>
                      visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
                    }
                  />
                </Form.Item>
              </div>
            </div>

            <div className="formInfoRow">
              <div className="formInfoCol">
                <Form.Item
                  label="Confirm Password"
                  name="confirmPwd"
                  hasFeedback
                  dependencies={["newPassword"]} // Add dependencies to revalidate when 'newPassword' changes
                  rules={[
                    {
                      required: true,
                      message: "Please input your confirm password",
                    },
                    // { min: 8, message: 'Password must be at least 8 characters long!' },
                    // {
                    //   pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
                    //   message: 'Password must include uppercase, lowercase, number, and special character!',
                    // },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("newPassword") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Passwords do not match")
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    placeholder="Confirm Password"
                    style={{ borderRadius: "5px" }}
                    iconRender={(visible) =>
                      visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
                    }
                  />
                </Form.Item>
              </div>
            </div>

            <div className="formInfoRow">
              <div className="formInfoCol">
                <Form.Item label=" " colon={false}>
                  <div
                    className="pwdUpdateBtn"
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      width: "100%",
                    }}
                  >
                    <Button
                      className="cancelBtn"
                      style={{ color: "black" }}
                      onClick={() => {
                        navigate("/");
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="greenBtn"
                      htmlType="submit"
                      onClick={() => form.submit()}
                    >
                      Update
                    </Button>
                  </div>
                </Form.Item>
              </div>
            </div>
          </Form>
          <div className="footerlogo" >
            <div onClick={() => window.open("https://www.connectsu.co.uk/", '_blank')} style={{ cursor: "pointer" }}>
              <img src={Logo} alt="powered-logo" />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default ChangePassword;
